<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<template>
  <div class="table-box">
    <!--查询-->
    <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />
    <!--列表-->
    <div class>
      <el-table
        style="width: 100%"
        v-loading="loading"
        row-key="id"
        ref="recordList"
        :data="tableData"
        :stripe="false"
        :highlight-current-row="false"
        header-row-class-name="noBorder"
      >
        <!-- <el-table-column
          type="selection"
          width="55"
          row-key="id"
          :reserve-selection="true"
        ></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="enterpriseName"
          label="企业"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="title"
          label="病例标题"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="上传时间"
        >
          <template slot-scope="scope">
            {{ scope.row.createDt | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="状态"
        >
          <template slot-scope="scope">
            {{ scope.row.auditGongyeStatus | transAuditStatus }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="check(scope.row)">查看</el-button> -->
            <el-button
              :disabled="scope.row.auditGongyeStatus !== 1"
              type="text"
              size="small"
              @click="approve(2, scope.row)"
            >
              通过
            </el-button>
            <rejectComponent
              :disabled="scope.row.auditGongyeStatus !== 1"
              @withdraw="item => approve(3, scope.row, 0, item)"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="check(scope.row)">查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="pass(scope,2)"
              :disabled="scope.row.authStatus!=1"
            >通过</el-button>
            <el-button
              type="text"
              size="small"
              @click="pass(scope,3)"
              :disabled="scope.row.authStatus!=1"
            >不通过</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import rejectComponent from '@/components/Task/components/reject.vue';
import { bingli, search, receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import OpenNewWin from '@/tools/openNewWin';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';

export default {
  mixins: [pageInation, makeSure, taskRecordHandles, approvalFlagMixins],
  data() {
    return {
      ruleForm: {}, // 用户信息
      getList: bingli.projectBingLiList, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        statementId: this.$route.query.statementId
      },
      searchAjax: search.yshEnterpriseList,
      prop: {
        label: 'enterpriseName',
        code: 'enterpriseId'
      }
    };
  },
  components: {
    dicSelect,
    rejectComponent
  },
  computed: {},
  methods: {
    check(row) {
      this.$router.push({
        name: 'caseRecordAddEdit',
        query: {
          id: row.id
        }
      });
    },
    exportEvent() {
      let queryString = this.$querystring.stringify(this.searchQuery);
      window.open(bingli.exportBingLiExcel + '?' + queryString);
    },
    saveEnterpriseId(val) {
      //保存
      this.searchQuery.enterpriseId = val.enterpriseId;
    },
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },

    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        bingli
          .authBingli({
            id: row.id,
            authStatus: status
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },

  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
</style>
